import { LBLabel, LBRadioGroup, LBRadioGroupItem } from '@linearb/buzz';
import { JIRA_HOSTS_TYPES } from './jira.oauth2.consts';
import { Tooltip } from '@material-ui/core';

const hostTypesOptions = [
  {
    value: JIRA_HOSTS_TYPES.CLOUD,
    name: 'Jira Cloud',
    description: 'Your data is hosted by Atlassian'
  },
  {
    value: JIRA_HOSTS_TYPES.SERVER,
    name: 'Jira Data Center',
    description: 'Your data stored  on-premises or in Attlasian Data Centers',
    disabled: true,
    tooltip: 'Coming soon'
  }
];

const JiraHostTypePicker = ({ value, onChange }) => {
  return (
    <div className='mt-4 flex flex-col gap-4'>
      <LBRadioGroup value={value} onValueChange={onChange}>
        {hostTypesOptions.map(option => {
          return (
            <div className='flex items-start gap-2' key={option.value}>
              <Tooltip
                title={option.tooltip}
                disableHoverListener={!option.tooltip}
                placement='top'
              >
                <div>
                  <LBRadioGroupItem
                    id={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  />
                </div>
              </Tooltip>
              <div className='flex flex-col items-start'>
                <LBLabel className='text-sm' htmlFor={option.value}>
                  {option.name}
                </LBLabel>
                <div className='text-muted-foreground text-sm'>
                  {option.description}
                </div>
              </div>
            </div>
          );
        })}
      </LBRadioGroup>
    </div>
  );
};

export default JiraHostTypePicker;
